//import './thesaurus-term-tree.scss'

import _ from 'lodash'
import Component from "vue-class-component"
import { Watch } from 'vue-property-decorator'

import { ThesaurusTerm, getTranslatedString } from '@skinsoft/types'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { ThesaurusTermDataStore } from '@skinsoft/entity'
import { ReactiveVue } from "@skinsoft/reactive-vue"
import ThesaurusTermTreeModal from "./thesaurus-term-tree-modal"

@Component({
    components: {
        sThesaurusTermTreeModal: ThesaurusTermTreeModal,
    },
    props: ['thesaurusIdentifier', 'startValue', 'placeholder', 'readOnly'],
    template: require('./thesaurus-term-tree.html')
})
export default class ThesaurusTermTree extends ReactiveVue {
    private thesaurusIdentifier: string
    private startValue: string
    private placeholder: string
    private readOnly: Boolean

    // @ts-ignore
    private startThesaurusTerm: ThesaurusTerm | null = null
    private $thesaurusTermDataStore: ThesaurusTermDataStore

    public $refs: {
        modal: ThesaurusTermTreeModal,
    }

    private mounted() {
        if(this.startValue) {
            this.$thesaurusTermDataStore.fetchOne(this.startValue).subscribe(thesaurusTerm => {
                if(thesaurusTerm && thesaurusTerm.id) {
                    this.startThesaurusTerm = thesaurusTerm
                }
            })
        }
    }

    private getThesaurusTermTitle(thesaurusTerm: ThesaurusTerm) {
        return getTranslatedString(thesaurusTermSelectors.preferredTerm(thesaurusTerm), this.getAppLocale())
    }

    private get startThesaurusTermTitle(): string {
        if(this.startThesaurusTerm) {
            return this.getThesaurusTermTitle(this.startThesaurusTerm)
        }
        return ''
    }

    private openModal() {
        if(!this.readOnly) {
            this.$refs.modal.openModal()
        }
    }

    @Watch('startValue')
    private onStartValueChanged() {
        if(this.startValue) {
            this.$thesaurusTermDataStore.fetchOne(this.startValue).subscribe(thesaurusTerm => {
                if(thesaurusTerm && thesaurusTerm.id) {
                    this.startThesaurusTerm = thesaurusTerm
                }
            })
        } else {
            this.startThesaurusTerm = null
        }
    }
}